import ReactDOM from 'react-dom/client';
import { Routes } from '@generouted/react-router';
// console.log(Routes().props.router.routes[0].children);
ReactDOM.createRoot(document.getElementById('root')!).render(<Routes />);
